<template functional>
    <li :data-date="props.revision.created_at | date_format('DD.MM YYYY')">
        <article class="timeline-item">
            <b-alert v-if="props.revision.type" show variant="info">
                <b>{{ parent.$t(props.revision.type) }}</b>
            </b-alert>
            <template v-if="props.revision.next">
                <b-alert v-if="props.revision.time_difference" show variant="warning">
                    <p><b>{{ parent.$t('Break: {0} min', [props.revision.time_difference]) }}</b></p>

                    <small class="font-weight-bold">{{ props.revision.next.created_at | time }}</small>
                    <b-breadcrumb
                        v-if="props.revision.next.breadcrumb"
                        class="ml-auto"
                    >
                        <b-breadcrumb-item
                            v-for="breadcrumb in props.revision.next.breadcrumb"
                            :key="breadcrumb.url"
                            :active="!breadcrumb.url"
                            :aria-current="null"
                            :html="breadcrumb.text"
                            :to="breadcrumb.url"
                        />
                    </b-breadcrumb>
                </b-alert>
            </template>

            <header>
                <small class="font-weight-bold">{{ props.revision.created_at | time }}</small>

                <b-breadcrumb
                    v-if="props.revision.breadcrumb"
                    class="ml-auto"
                >
                    <b-breadcrumb-item
                        v-for="breadcrumb in props.revision.breadcrumb"
                        :key="breadcrumb.url"
                        :active="!breadcrumb.url"
                        :aria-current="null"
                        :html="breadcrumb.text"
                        :to="breadcrumb.url"
                    />
                </b-breadcrumb>
            </header>
            <p v-html="props.revision.message" />
        </article>
    </li>
</template>
<script>
    export default {
        name: 'BreakHistoryItem',
        props: {
            revision: {
                type: Object,
                required: true
            },
        }
    }
</script>
